import { render, staticRenderFns } from "./unqualified.vue?vue&type=template&id=00df72bf&scoped=true&"
import script from "./unqualified.vue?vue&type=script&lang=js&"
export * from "./unqualified.vue?vue&type=script&lang=js&"
import style0 from "./unqualified.vue?vue&type=style&index=0&id=00df72bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df72bf",
  null
  
)

export default component.exports